import { map } from "rxjs";
import { Plan } from "../../model";
import apiService from "../ApiService";

const passSubscribe = (plan: Plan) => {
  return apiService
    .post<{ checkoutSessionUrl: string }>({
      path: "public/store/stripe/checkout_session",
      crm: true,
      body: {
        plan: plan.publicId,
      },
    })
    .pipe(map((e) => e.checkoutSessionUrl));
};
export { passSubscribe };
